import { render } from "./NegativeStepCard.vue?vue&type=template&id=528d93a2&scoped=true"
import script from "./NegativeStepCard.vue?vue&type=script&lang=js"
export * from "./NegativeStepCard.vue?vue&type=script&lang=js"

import "./NegativeStepCard.vue?vue&type=style&index=0&id=528d93a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528d93a2"]])

export default __exports__